exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-1894e335]:hover{text-decoration:underline}.center-content[data-v-1894e335]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.baner-carousel[data-v-1894e335]{padding:7.5px 0;width:440px;margin:0 auto;height:15px}@media only screen and (min-device-width: 768px) and (max-device-width: 1024px){.baner-carousel[data-v-1894e335]{height:30px;width:100%}}@media (max-width: 767px){.baner-carousel[data-v-1894e335]{height:30px;width:100%}}@media (max-width: 767px){.top-bar-text[data-v-1894e335]{font-size:10px}}\n", ""]);

// exports
